import apollo from 'graphql/apollo';
import { moveItemMutation } from 'graphql/mutations';

const moveCategoryItem = (categoryListQuery) => async ({ _id, offset, order }) =>
  apollo.mutate({
    mutation: moveItemMutation,
    variables: { _id, offset, order },
    refetchQueries: [{ query: categoryListQuery }],
  });
export default moveCategoryItem;
